import { Home, Globe, Phone, Heart, Leaf } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";
import { FOOTER_IMAGE, THC } from "@/lib/tankHealthCheck";

const BLOCKS = [
  [Home, "SAFER", "HOMES"],
  [Heart, "HEALTHIER", "LIFESTYLES"],
  [Leaf, "BRIGHTER", "FUTURES"],
];

export function CampaignFooter() {
  return (
    <footer id="about-us" className="relative mt-10 md:mt-16 overflow-hidden" data-testid="thc-footer">
      <img src={FOOTER_IMAGE} alt="" aria-hidden="true" loading="lazy"
        className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(90deg,#062B5C 0%,rgba(7,58,122,0.92) 45%,rgba(7,58,122,0.55) 100%)" }} />
      <div className="relative mx-auto max-w-[1440px] px-[18px] md:px-7 xl:px-10 py-8 md:py-10">
        <div className="grid gap-7 md:grid-cols-[minmax(0,30%)_minmax(0,34%)_minmax(0,36%)] md:items-center">
          <BrandLogo to="/" variant="dark" size="lg" />
          <ul className="space-y-2 text-white text-[15px] md:text-[16px]">
            <li className="flex items-start gap-2.5">
              <Home className="w-[18px] h-[18px] mt-0.5 shrink-0" style={{ color: THC.bright }} aria-hidden="true" />
              <span>1/37 Gateway Drive<br />Noosaville, QLD 4566</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Globe className="w-[18px] h-[18px] shrink-0" style={{ color: THC.bright }} aria-hidden="true" />
              <a href="https://awarewatertesting.com.au" className="underline-offset-2 hover:underline">awarewatertesting.com.au</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone className="w-[18px] h-[18px] shrink-0" style={{ color: THC.bright }} aria-hidden="true" />
              <a href="tel:0753273473" className="underline-offset-2 hover:underline">Ph: 5327 3473</a>
            </li>
          </ul>
          <div className="flex items-start gap-5">
            {BLOCKS.map(([Icon, a, b]) => (
              <div key={a} className="text-center text-white">
                <span className="w-[54px] h-[54px] rounded-full grid place-items-center mx-auto"
                  style={{ backgroundColor: THC.blue }}>
                  <Icon className="w-6 h-6 text-white" aria-hidden="true" />
                </span>
                <div className="mt-1.5 text-[12.5px] font-bold uppercase leading-tight">{a}<br />{b}</div>
              </div>
            ))}
            <p className="hidden xl:block ml-auto self-center text-[24px] leading-tight text-white font-semibold"
              style={{ fontFamily: "'Caveat',cursive" }}>
              A Cleaner, Healthier<br />Sunshine Coast
            </p>
          </div>
        </div>
        <div className="mt-7 pt-4 border-t border-white/25 flex flex-col sm:flex-row gap-2 sm:items-center justify-between text-white/85 text-[13.5px]">
          <div className="flex flex-wrap gap-4">
            <a href="/privacy" className="hover:text-white">Privacy Policy</a>
            <a href="/terms" className="hover:text-white">Terms &amp; Conditions</a>
            <a href="/contact" className="hover:text-white">Contact Us</a>
          </div>
          <p>Locally trusted. Independently tested. A healthier tomorrow.</p>
        </div>
      </div>
    </footer>
  );
}
